export default __webpack_public_path__ + "static/media/bandeira_jp.a172b29c.png";